import type { FaireProductEntity } from "../../entity_types/product";

export const p_rundgrzsna: FaireProductEntity = {
  token: "p_rundgrzsna",
  type: "product",
  name: "Custom Youth Hooded Sweatshirt  -Youth",
  brandToken: "b_n9fwmzzqs5",
  brandName: "Unknown Brand",
  imageUrl:
    "https://cdn.faire.com/fastly/e8f7db1dc62ed8387b4536076613726c8cc3f07eb925504e9be26a9206e63c80.jpeg",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/98444db8607ab8a5150d0308e3ac2dcfc97b349f9764ea2f1483fe99600350fb.jpeg",
    "https://cdn.faire.com/fastly/7f1a75d6100fc55658b49c967f7bfdbe5439468b16d2c744b58955802e28a97c.jpeg",
    "https://cdn.faire.com/fastly/c5760facf54891d176c21bfe5574477caa5f92810bdd47bdd6396b058c2e6591.jpeg",
  ],
  priceDollars: 38.73,
  description:
    "Custom Youth Sweatshirt /Hooded Sweatshirt \n\n👍Personalize these ultra comfy tees with your logo, artwork or words in any single print \n \n(please send me your file to here  [redacted-email])\n\n✌️If you have artwork, message us your image file before purchase to be sure we can get a good \n     print from it. We can print multi color designs!\n\n  👍We will send you a proof/mockup to approve, and make any adjustments, before printing. \n\n👌Keep in mind that we will not print anything copyrighted or trademarked. \n\n ** Toddler Fleece Sweatshirt**\n\n7.5 oz./yd² (US), 12.5 oz./L yd (CA), 60/40 cotton/polyester\n\nWhite is sewn with 100% cotton thread\n\nCoverstitched collar, shoulders, armholes, ribbed cuffs and waistband\n\nCPSIA compliant tracking label on side seam\n\n👕 Unmatched Softness: Dive into a world of unparalleled comfort with our supremely soft fabric. Each touch is a gentle embrace, ensuring you feel relaxed all day long.\n\n",
  tags: [],
  msrpDollars: 77.46,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-03-26T22:26:25.818Z",
    importedBy: "entity-db-cli",
  },
  categoryTokens: [],
};
